import React from 'react'
import "./InstitutionCard.css"
import { GiRotaryPhone } from "react-icons/gi"
import { GoMailRead } from "react-icons/go"
import { useNavigate } from 'react-router-dom'
import { BASE_URL, CDN_BASE_URL } from '../../constants/constants'



const InstitutionCard = (props) => {
    const { id, libelle, telephone, email, logo, category_institution } = props.data;
    const navigate = useNavigate()
    return (
        <div className='institution-card mx-auto' >
            <p>
            <img src={`${CDN_BASE_URL}${logo}`} className='institution-card-img' />
            </p>
            <br />
            <div className='my-auto'>
                <p className='institution-card-libelle'>{libelle}</p>
                <p className='institution-card-category'>- {category_institution.libelle}</p>
                <p className='institution-card-tel'><GiRotaryPhone style={{ width: 25, height: 25, marginRight: 5, color: "rgba(0, 136, 193, 0.9)" }} /> {telephone}</p>
                <p className='institution-card-mail'><GoMailRead style={{ width: 25, height: 25, marginRight: 5, color: "rgba(0, 136, 193, 0.9)" }} />{email}</p>
            </div>
            <p  className='institution-card-details' 
                onClick={() => navigate(`/institution/${id}`)}>Voir détails »</p>
        </div>
    )
}

export default InstitutionCard